// 查找元素element是否有指定class selector的父元素，查找最近的
export function closest(element, selector) {
  if (!element) {
    return null;
  }

  const matchFunction = Element.prototype.matches 
    || Element.prototype.webkitMatchesSelector 
    || Element.prototype.mozMatchesSelector 
    || Element.prototype.msMatchesSelector;

  function conditionFn(currentElement) {
    if (!currentElement) {
      return currentElement;
    } else {
      return matchFunction.call(currentElement, selector);
    }
  }

  let current = element;
  do {
    if (conditionFn(current)) {
      return current;
    }

    current = current.parentNode;
  } while (current && current !== document.body && current !== document);

  return null;
}